import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";
import {SideMenuEnum} from "@app/enums/SideMenuEnum";
import {Router} from "@angular/router";

@Injectable({providedIn: 'root'})
export class SidebarStateService {
  private readonly _shrunk = new BehaviorSubject<boolean>(false);
  readonly shrunk$ = this._shrunk.asObservable();

  get isShrunk(): boolean {
    return this._shrunk.value;
  }

  private readonly _openMenu = new BehaviorSubject<SideMenuEnum | null>(null);

  // Map menu enums to their base route paths
  private readonly menuRoutePaths: Map<SideMenuEnum, string> = new Map([
    [SideMenuEnum.Admininstration, '/admin/administration/'],
    [SideMenuEnum.BusinessOverview, '/admin/business-overview/'],
  ]);

  constructor(private router: Router) {}

  setShrunk(v: boolean): void {
    if (this._openMenu.value !== null && v) return;
    this._shrunk.next(v);
  }

  handleHover(url: string, isHovering: boolean): void {
    this.setShrunk(!isHovering);
  }

  toggleMenu(menu: SideMenuEnum): void {
    const isAlreadyOpen = this._openMenu.value === menu;
    this._openMenu.next(isAlreadyOpen ? null : menu);
    if (!isAlreadyOpen) this._shrunk.next(false);
  }

  isMenuActive(menu: SideMenuEnum): boolean {
    return this._openMenu.value === menu;
  }

  isMenuHighlighted(menu: SideMenuEnum): boolean {
    if (this._openMenu.value === menu) {
      return true;
    }
    
    const menuPath = this.menuRoutePaths.get(menu);
    return menuPath ? this.router.url.startsWith(menuPath) : false;
  }
}
